/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
// chakra imports

function isLinkActive(currentPath, linkPath) {
    if (linkPath === "new-activation") {
        return currentPath === "/my/new-activation";
    } else if (linkPath === "activation-history") {
        return (
            currentPath === "/my/activation-history" ||
            currentPath.includes("/my/activation-details/")
        );
    } else if (linkPath === "pending-activations") {
        return currentPath === "/my/pending-activations";
    } else if (linkPath === "servers") {
        return currentPath.includes("my/server");
    } else if (linkPath === "domains") {
        return currentPath.includes("my/domain");
    }
}

export function SidebarLinks(props) {
    // Chakra color mode
    let location = useLocation();

    const { routes, closeSidebar } = props;

    // verifies if routeName is the one active (in browser input)
    const activeRoute = (routeName) => {
        return location.pathname.includes(routeName);
    };

    const createLinks = (routes) => {
        return routes.map((route, index) => {
            if (route.layout === "/my" && route.sidebar === true) {
                return (
                    <Link
                        key={index}
                        to={route.layout + "/" + route.path}
                        onClick={closeSidebar}
                    >
                        <div className="relative mb-3 flex hover:cursor-pointer">
                            <li
                                className="my-[3px] flex cursor-pointer items-center px-8"
                                key={index}
                            >
                                <span
                                    className={`${
                                        activeRoute(route.path) === true
                                            ? "font-bold text-brand-500 dark:text-white"
                                            : "font-medium text-gray-700"
                                    }`}
                                >
                                    {route.icon ? route.icon : <DashIcon />}{" "}
                                </span>
                                <p
                                    className={`leading-1 ml-4 flex ${
                                        activeRoute(route.path) === true
                                            ? "ml-3 font-bold text-navy-700 dark:text-white"
                                            : "font-medium text-gray-700"
                                    }`}
                                >
                                    {route.name}
                                </p>
                            </li>
                            {isLinkActive(location.pathname, route.path) ? (
                                <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
                            ) : null}
                        </div>
                    </Link>
                );
            }
        });
    };
    // BRAND
    return createLinks(routes);
}

export default SidebarLinks;
